import { useState } from "react";
import { toast } from "sonner";
import { api, setToken } from "@/lib/api";
import { ToothLogo } from "@/components/ToothLogo";

export default function AdminLogin({ onLogin }) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/auth/login", { email, password });
      setToken(data.token);
      toast.success("Bienvenido");
      onLogin();
    } catch (err) {
      toast.error(err.response?.data?.detail || "No se pudo iniciar sesión");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="grid min-h-[100dvh] place-items-center bg-neutral-50 px-6">
      <form
        onSubmit={submit}
        className="w-full max-w-sm rounded-3xl border border-neutral-200 bg-white p-8 shadow-sm"
      >
        <div className="mb-6 flex justify-center">
          <img
            src="/assets/logo.webp"
            alt="odontopick"
            className="h-7 w-auto object-contain"
          />
        </div>
        <h1 className="font-brand text-xl font-semibold text-neutral-900">Panel de administración</h1>
        <p className="mb-6 mt-1 text-sm text-neutral-500">Ingresa con tu cuenta de administrador.</p>

        <label className="mb-1.5 block text-sm font-medium text-neutral-700">Correo</label>
        <input
          data-testid="admin-email-input"
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
          className="mb-4 w-full rounded-xl border border-neutral-200 px-4 py-3 outline-none focus:border-neutral-900"
          placeholder="admin@odontopick.com"
        />
        <label className="mb-1.5 block text-sm font-medium text-neutral-700">Contraseña</label>
        <input
          data-testid="admin-password-input"
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
          className="mb-6 w-full rounded-xl border border-neutral-200 px-4 py-3 outline-none focus:border-neutral-900"
          placeholder="••••••••"
        />
        <button
          data-testid="admin-login-btn"
          disabled={loading}
          className="w-full rounded-xl bg-neutral-900 py-3 font-medium text-white transition-colors hover:bg-neutral-800 disabled:opacity-60"
        >
          {loading ? "Ingresando…" : "Ingresar"}
        </button>
      </form>
    </div>
  );
}
